import React, { FunctionComponent } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';

const useStyles = () => {
  const { spacing } = useTheme();
  return {
    root: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      top: spacing(-5),
      background: `linear-gradient(
        180deg,
        rgba(0,10,20,0.00) 0%,
        rgba(0,10,20,0.15) 25%,
        rgba(0,10,20,0.50) 100%
      )`,
    },
  } as const;
};

const Overlay: FunctionComponent = () => {
  const classes = useStyles();

  return <div data-testid="Overlay" css={classes.root} />;
};

export default Overlay;
